const APIS_CONSTANTS = {
  tags: "/yeshtery/tags",
  shops: "/yeshtery/shops",
  product: "/yeshtery/product",
  products: "/yeshtery/products",
  events: "/event/all",
  event: "/event",
  eventInterest: "/event/interset",
  eventInterests: "/event/interests",
  organization: "/yeshtery/organization",
  chatSettings: "/chat-widget-setting",
  // The sentence the brand's owner wrote inviting a visitor to create an
  // account. Unauthenticated, and answers {"line": ""} for a brand that wrote
  // none - which is nearly all of them, so an empty answer is normal.
  guestSignInOffer: "/chat-widget-setting/guest-sign-in-offer",
  info: "/user/info",
  login: "/yeshtery/token",
  logout: "/user/logout",
  register: "/user/register",
  recover: "/user/recover",
  otpVerify: "/user/recovery/otp-verify",
  otpActivate: "/user/register/otp/activate",
  resendOtp: "/user/register/activate/resend",
  newPassword: "/user/recover",
  leaveSession: "/videochat/leave",
  listActiveEmployee: "/employee-user-heart-beats-logs/list-active-employee",
  getSession: "/queue",
  userNotification: "/user/notification-token",
  getAppConfig: "/frontend/setting",
  getProductsByIds: "/yeshtery/products_by_ids",
  cartItem: "/cart/item",
  getMessagesByChat: "/message/by-chat",
  getChatByUserId: "/chat/user",
  // A visitor who has not signed in gets a token that names a guest customer
  guestSession: "/chat/guest-session",
  // The visitor who has just created an account keeps the conversation and
  // everything the shop learned about them while they were anonymous.
  guestMerge: "/chat/guest-merge",
  // What the shopper did, filed against them. Sent from here rather than from
  // the SDK because the backend needs the shopper's own token to name them.
  trackingEvents: "/tracking-systems-events",

  // Group channels endpoints
  getGroupChannels: "/social/group/channels",
  getGroupMessages: "/social/group/messages",
  joinGroup: "/social/group/join/channel",
  getGroupDetails: "/social/group",
  getGroupChannelsForGuests: "/social/group/channels/public",

  // User chat data endpoint
  getUserChatData: "/user/chat",

  // User avatar upload
  uploadUserAvatar: "/user/uploadUserAvatar",

  // User update
  updateUser: "/user/update",

  // Referral endpoints
  referralSendOtp: "/referral/sendOtp",
  referralVerifyOtp: "/referral/validate-otp",
  referralLink: "/referral",
  referralResendOtp: "/referral/resendOtp",
  referralChildren: "/referral/childs",
  bankAccountSummary: "/bank/account/summary",
  // Wallet API endpoints
  getWalletAccount: "/bank/account",
  getPointsHistory: "/bank/account/history",
  getWalletTier: "/loyalty/tier",
  getGoogleWalletQrCode: "/wallet/google/qrCode",
  getAppleWalletQrCode: "/wallet/apple/qrCode",
  getWalletDesign: "/organization/loyalty-wallet/organization/tier",

  // Bank Account API endpoints
  createBankAccount: "/bank/account",

  // Quests endpoints
  getQuests: "/quests",

  /** chat service endpoints with ( node server ) start */
  // user controller start
  // jwtToken: "/user",
  // getUserData: "/user",

  // // chat-controller start
  // createChat: "/chat",
  // getChat: "/chat",

  // // message-controller start
  // sendMessage: "/message",
  // getMessagesHistory: "/messages",
  // sendMessageToBot: "/bot-message",

  // // bot-controller start
  // getBotToken: "/botToken",
};

export default APIS_CONSTANTS;
